import {
  GET_UNITS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_UNITS,
  UPDATE_UNITS,
  DELETE_UNITS,
  CREATE_DEPARTMENT,
} from "./actionType";

const INIT_STATE = {
  units: [],
  error: {},
  success: "",
};

const Units = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_UNITS:
          return {
            ...state,
            units: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_UNITS:
          return {
            ...state,
            success: "Successfully created",
            error: {},
          };
        case UPDATE_UNITS:
          return {
            ...state,
            success: "Successfully updated",
            error: {},
          };
        case DELETE_UNITS:
          return {
            ...state,
            success: "Successfully Deleted",
            error: {},
          };
        case CREATE_DEPARTMENT:
          return {
            ...state,
            success: "Successfully created",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_UNITS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_UNITS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_UNITS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_UNITS:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_DEPARTMENT:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_UNITS: {
      return {
        ...state,
      };
    }
    case CREATE_UNITS: {
      return {
        ...state,
      };
    }
    case UPDATE_UNITS:
      return {
        ...state,
      };
    case DELETE_UNITS:
      return {
        ...state,
      };
    case CREATE_DEPARTMENT: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Units;
